import React, { useRef } from 'react';
import { Button, Container, Typography, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/logoXIXbiale.png';

const Home = ({ setRole }) => {
  const navigate = useNavigate();
  const tapCount = useRef(0);
  const tapTimeout = useRef(null);

  const handleParticipantClick = () => {
    setRole('participant');
    navigate('/calendar');
  };

  const handleLogoTap = () => {
    tapCount.current += 1;

    if (tapTimeout.current) clearTimeout(tapTimeout.current);
    tapTimeout.current = setTimeout(() => {
      tapCount.current = 0;
    }, 3000);

    if (tapCount.current >= 5) {
      tapCount.current = 0;
      setRole('organizer');
      navigate('/login');
    }
  };

  return (
    <Container>
      <Box textAlign="center" mt={5}>
        <Typography
          variant="h4"
          gutterBottom
          sx={{ color: 'white', fontFamily: 'Roboto, sans-serif' }}
        >
          Co chcesz zrobić?
        </Typography>
        <Button
          variant="contained"
          sx={{ backgroundColor: '#22c55e', m: '10px', color: 'black' }}
          onClick={handleParticipantClick}
        >
          Sprawdź tablicę
        </Button>
        <Button
          variant="contained"
          sx={{ backgroundColor: 'black', m: '10px', color: '#22c55e' }}
          onClick={() => navigate('/submit')}
        >
          Zgłoś warsztat
        </Button>
        <Box display="flex" justifyContent="center" mt={8}>
          <img
            src={logo}
            alt="Logo Festiwalu Enklawa"
            style={{ maxWidth: '60%', height: 'auto', cursor: 'pointer' }}
            onClick={handleLogoTap}
          />
        </Box>
      </Box>
    </Container>
  );
};

export default Home;
